<template>
    <v-col cols="12" class="RequestTracking mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%"
        >
            <v-col cols="12" lg="3" >
                <v-card
                        class="pa-4 elevation-0"
                        tile
                        height="100%"
                >
                    <v-row class="jsutify-center text-center">
                        <v-col>
                            <p class="text-center font-weight-medium">Estás Trabajando En</p>
                            <v-card
                                class="pa-4 ma-0 elevation-5 mx-auto"
                                tile
                                height="150px"
                                    width="150px"
                            >
                                    <v-img src="@/assets/images/neocity-logo.png"
                                            height="130px"
                                            width="130px"
                                            aspect-ratio="2"
                                            contain>
                                    </v-img>
                                    
                            </v-card>
                            <h5 class="mt-4">NOMBRE EMPRESA</h5>
                            <h5 class="green--text">00.000.000-0</h5>
                        </v-col>
                     
                    </v-row>
                    <v-row class="jsutify-center text-center">
                        <v-col class="d-flex justify-center">
                            <v-btn 
                                color="primary"
                                outlined
                                class="px-6 mx-6"><v-icon>mdi-home-edit-outline</v-icon> Editar Empresa
                            </v-btn>
                             <v-btn 
                                color="primary"
                                dark
                                class="px-6 mx-6"><v-icon>mdi-finance</v-icon> Ver gráficos
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row class="jsutify-center text-center">
                        <v-col cols="12">
                           
                        </v-col>
                        
                    </v-row>
                 
                        
                  
                   

                </v-card>
            </v-col>
             <v-col cols="12" lg="9" >
                <v-card
                        class="pa-4 elevation-0 text-center"
                        tile
                        height="100%"
                >
                    <v-row>
                        <v-col cols="12">
                            <v-toolbar
                                height="60"
                                dense
                                class="pasos-contrato align-center"
                            >
                                <v-toolbar-title class="first">Pasos para el contrato</v-toolbar-title>
                                <v-toolbar-title class="step second active">1. Selecciona puntos<br> de retiro</v-toolbar-title>
                                <v-toolbar-title class="step active"> Cotiza Energia</v-toolbar-title>
                                <v-toolbar-title class="step active"> Confirmando <br>tu cotizacion</v-toolbar-title>
                                <v-toolbar-title class="step"> Cierra tu<br> suministro</v-toolbar-title>

                            </v-toolbar>
                        </v-col>
                    </v-row>
                    
                    <h2 class="text-center font-weight-medium mt-10 font-size-40">Seguimiento de solicitudes</h2>
                    <i class="text-center blue--text">A continuacción encontraras todas tus solicitudes enviadas y su estado de avance</i>
                   
                   
                    
                            <v-card class="pa-4 elevation-0 text-left ">
                                 <v-row class="caption align-center">
                                    <v-col cols="4" lg="2"> <v-icon>mdi-dip-switch</v-icon> Filtros</v-col>
                                   <v-spacer></v-spacer>
                                    <v-col class="d-flex align-center justify-end" cols="4" lg="2">
                                        <v-btn @click="viewMode = 'table'" class="" tile large :color="viewMode == 'table' ? 'blue' : 'grey'" dense icon>
                                            <v-icon>mdi-view-list</v-icon>
                                        </v-btn>
                                        <v-btn @click="viewMode = 'card'" class="" tile large :color="viewMode == 'card' ? 'blue' : 'grey'" dense icon>
                                            <v-icon>mdi-view-grid</v-icon>
                                        </v-btn>
                                    </v-col>
                                    <v-col cols="12" lg="2">
                                        <v-text-field
                                                class="buscador tipo1"
                                                placeholder="Buscar en"
                                                outlined
                                                append-icon="mdi-magnify"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                              
                                <v-row >
                                    <v-col class="border-left-blue border-bottom-2 pa-0" cols="12" lg="4">
                                       <v-card
                                        color="#F2F2FA"
                                        height="57"
                                        elevation="0"
                                        class="bar-info-offers mb-10"
                                       >    
                                        <v-card-title class="pa-0">
                                            
                                                <v-col cols="3" class="text-center white--text blue darken-4">
                                                    <v-icon color="white">mdi-weather-night</v-icon>
                                                    A
                                                </v-col>
                                                <v-col cols="2" class="text-center pa-0">
                                                    <p class="caption mb-0">estado</p>
                                                    <v-icon color="#439A03">mdi-check-circle</v-icon>
                                                </v-col>
                                                <v-col class="pa-0" cols="4">
                                                    <p class="caption mb-0">Horario</p>
                                                    <h5>0am a 8am</h5>
                                                </v-col>
                                                <v-col class="pa-0" cols="3" >
                                                    <p class="caption mb-0">Requiere</p>
                                                    <h3>10MW</h3>
                                                </v-col>

                                        </v-card-title>
                                       </v-card> 
                                       <v-card 
                                            class="outline-0 py-6 px-3 ma-6 card-max-width mx-auto rounded-xl text-center overflow-hidden outline-green"
                                            color="#fff">
                                            <v-img
                                                    class="mx-auto"
                                                    max-width="70%"
                                                    alt="Neocity Logo"
                                                    src="@/assets/images/neocity-logo.png"
                                                    contain
                                            ></v-img>
                                            <v-col class="mx-auto" cols="8">
                                                <b>
                                                     A - 1000<br>
                                                    X. Los Lagos, 220Kv<br>
                                                    +50 MW
                                                </b>
                                            </v-col>
                                            <div class="mx-auto">
                                                <v-chip
                                                        class="ma-2"
                                                        color="#004E85"
                                                        label
                                                        text-color="white"
                                                >
                                                    A
                                                </v-chip>
                                                
                                            </div>
                                            <div class="mx-auto">
                                                <b>6 Meses</b>
                                            </div>
                                            <b>Precio: <span class="green--text">30 USD/MWh</span></b>
                                            <v-rating
                                                    :value="'4'"
                                                    readonly
                                                    background-color="orange lighten-3"
                                                    color="orange"
                                                    >
                                            </v-rating>
                                            <v-progress-linear height="10px"
                                                color="green"
                                                value="70">
                                            </v-progress-linear>
                                            <v-row justify="start" class="align-center text-left">
                                                <v-col class="my-0 py-0 text-left">1.Solicitud</v-col>
                                                <v-col class="my-0 py-0">
                                                    <v-btn class="ma-2" tile large color="green" dense icon>
                                                        <v-icon>mdi-check-box-outline</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-row justify="start" class="align-center text-left">
                                                <v-col class="my-0 py-0 text-left">2.Respuesta Suministro</v-col>
                                                <v-col class="my-0 py-0">
                                                    <v-btn class="ma-2" tile large color="green" dense icon>
                                                        <v-icon>mdi-check-box-outline</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-row justify="start" class="align-center text-left">
                                                <v-col class="my-0 py-0 text-left">3.Cierre</v-col>
                                                <v-col class="my-0 py-0">
                                                    <v-btn class="ma-2" tile large color="grey" dense icon>
                                                        <v-icon>mdi-check-box-outline</v-icon>
                                                    </v-btn>
                                                    <v-btn class="ma-2" tile large color="grey" dense icon>
                                                        <v-icon>mdi-close-box-outline</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                                
                                            <v-row>
                                                <v-col class="justify-center text-center">
                                                    <a href="#" class="text-decoration-none">Ver detalles</a>
                                                    
                                                </v-col>
                                            </v-row>
                                           
                                       </v-card>
                                        <v-card 
                                            class="outline-0 py-6 px-3 ma-6 card-max-width mx-auto rounded-xl text-center overflow-hidden outline-green"
                                            color="#fff">
                                            <v-img
                                                    class="mx-auto"
                                                    max-width="70%"
                                                    alt="Neocity Logo"
                                                    src="@/assets/images/neocity-logo.png"
                                                    contain
                                            ></v-img>
                                            <v-col class="mx-auto" cols="8">
                                                <b>
                                                     A - 1000<br>
                                                    X. Los Lagos, 220Kv<br>
                                                    +50 MW
                                                </b>
                                            </v-col>
                                            <div class="mx-auto">
                                                <v-chip
                                                        class="ma-2"
                                                        color="#004E85"
                                                        label
                                                        text-color="white"
                                                >
                                                    A
                                                </v-chip>
                                               
                                            </div>
                                            <div class="mx-auto">
                                                <b>6 Meses</b>
                                            </div>
                                            <b>Precio: <span class="green--text">30 USD/MWh</span></b>
                                            <v-rating
                                                    :value="'4'"
                                                    readonly
                                                    background-color="orange lighten-3"
                                                    color="orange"
                                                    >
                                            </v-rating>
                                            <v-progress-linear height="10px"
                                                color="green"
                                                value="70">
                                            </v-progress-linear>
                                            <v-row justify="start" class="align-center text-left">
                                                <v-col class="my-0 py-0 text-left">1.Solicitud</v-col>
                                                <v-col class="my-0 py-0">
                                                    <v-btn class="ma-2" tile large color="green" dense icon>
                                                        <v-icon>mdi-check-box-outline</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-row justify="start" class="align-center text-left">
                                                <v-col class="my-0 py-0 text-left">2.Respuesta Suministro</v-col>
                                                <v-col class="my-0 py-0">
                                                    <v-btn class="ma-2" tile large color="green" dense icon>
                                                        <v-icon>mdi-check-box-outline</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-row justify="start" class="align-center text-left">
                                                <v-col class="my-0 py-0 text-left">3.Cierre</v-col>
                                                <v-col class="my-0 py-0">
                                                    <v-btn class="ma-2" tile large color="grey" dense icon>
                                                        <v-icon>mdi-check-box-outline</v-icon>
                                                    </v-btn>
                                                    <v-btn class="ma-2" tile large color="grey" dense icon>
                                                        <v-icon>mdi-close-box-outline</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col class="justify-center text-center">
                                                    <a href="#" class="text-decoration-none">Ver detalles</a>
                                                    
                                                </v-col>
                                            </v-row>
                                           
                                       </v-card>
                                    </v-col>
                                    <v-col class="border-left-yellow border-bottom-2 pa-0" cols="12" lg="4">
                                        <v-card
                                        color="#FFF6E5"
                                        height="57"
                                        class="bar-info-offers mb-10"
                                        elevation="0"
                                       >    
                                        <v-card-title class="pa-0">
                                            
                                                <v-col class="text-center white--text yellow darken-3">
                                                    <v-icon color="white">mdi-white-balance-sunny</v-icon>
                                                    B
                                                </v-col>
                                                <v-col cols="2" class="text-center pa-0">
                                                    <p class="caption mb-0">estado</p>
                                                    <v-icon color="#FD4200">mdi-close-circle</v-icon>
                                                </v-col>
                                                <v-col class="pa-0" cols="4">
                                                    <p class="caption mb-0">Horario</p>
                                                    <h5>8am a 20am</h5>
                                                </v-col>
                                                <v-col class="pa-0" cols="3" >
                                                    <p class="caption mb-0">Requiere</p>
                                                    <h3>30MW</h3>
                                                </v-col>
                                        </v-card-title>
                                       </v-card> 
                                        <v-card 
                                            class="outline-0 py-6 px-3 ma-6 card-max-width mx-auto text-center rounded-xl overflow-hidden outline-green"
                                            color="#fff">
                                            <v-img
                                                    class="mx-auto"
                                                    max-width="70%"
                                                    alt="Neocity Logo"
                                                    src="@/assets/images/neocity-logo.png"
                                                    contain
                                            ></v-img>
                                            <v-col class="mx-auto" cols="8">
                                                <b>
                                                     A - 1000<br>
                                                    X. Los Lagos, 220Kv<br>
                                                    +50 MW
                                                </b>
                                            </v-col>
                                            <div class="mx-auto">
                                                <v-chip
                                                        class="ma-2"
                                                        color="#004E85"
                                                        label
                                                        text-color="white"
                                                >
                                                    A
                                                </v-chip>
                                                <v-chip
                                                        class="ma-2"
                                                        color="#FF9A1B"
                                                        label
                                                        text-color="white"
                                                >
                                                    B
                                                </v-chip>
                                                <v-chip
                                                        class="ma-2"
                                                        color="#0172C0"
                                                        label
                                                        text-color="white"
                                                >
                                                    C
                                                </v-chip>
                                            </div>
                                            <div class="mx-auto">
                                                <b>6 Meses</b>
                                            </div>
                                            <b>Precio: <span class="green--text">30 USD/MWh</span></b>
                                            <v-rating
                                                    :value="'4'"
                                                    readonly
                                                    background-color="orange lighten-3"
                                                    color="orange"
                                                    >
                                            </v-rating>
                                           <v-row justify="start" class="align-center text-left">
                                                <v-col class="my-0 py-0 text-left">1.Solicitud</v-col>
                                                <v-col class="my-0 py-0">
                                                    <v-btn class="ma-2" tile large color="grey" dense icon>
                                                        <v-icon>mdi-check-box-outline</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-row justify="start" class="align-center text-left">
                                                <v-col class="my-0 py-0 text-left">2.Respuesta Suministro</v-col>
                                                <v-col class="my-0 py-0">
                                                    <v-btn class="ma-2" tile large color="grey" dense icon>
                                                        <v-icon>mdi-check-box-outline</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-row justify="start" class="align-center text-left">
                                                <v-col class="my-0 py-0 text-left">3.Cierre</v-col>
                                                <v-col class="my-0 py-0">
                                                    <v-btn class="ma-2" tile large color="grey" dense icon>
                                                        <v-icon>mdi-check-box-outline</v-icon>
                                                    </v-btn>
                                                    <v-btn class="ma-2" tile large color="grey" dense icon>
                                                        <v-icon>mdi-close-box-outline</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col class="justify-center text-center">
                                                    <a href="#" class="text-decoration-none">Ver detalles</a>
                                                    
                                                </v-col>
                                            </v-row>
                                           
                                       </v-card>
                                        <v-card 
                                            class="outline-0 py-6 px-3 ma-6 card-max-width mx-auto text-center rounded-xl overflow-hidden outline-green"
                                            color="#fff">
                                            <v-img
                                                    class="mx-auto"
                                                    max-width="70%"
                                                    alt="Neocity Logo"
                                                    src="@/assets/images/neocity-logo.png"
                                                    contain
                                            ></v-img>
                                            <v-col class="mx-auto" cols="8">
                                                <b>
                                                     A - 1000<br>
                                                    X. Los Lagos, 220Kv<br>
                                                    +50 MW
                                                </b>
                                            </v-col>
                                            <div class="mx-auto">
                                                <v-chip
                                                        class="ma-2"
                                                        color="#FF9A1B"
                                                        label
                                                        text-color="white"
                                                >
                                                    B
                                                </v-chip>
                                            </div>
                                            <div class="mx-auto">
                                                <b>6 Meses</b>
                                            </div>
                                            <b>Precio: <span class="green--text">30 USD/MWh</span></b>
                                            <v-rating
                                                    :value="'4'"
                                                    readonly
                                                    background-color="orange lighten-3"
                                                    color="orange"
                                                    >
                                            </v-rating>
                                            <v-row justify="start" class="align-center text-left">
                                                <v-col class="my-0 py-0 text-left">1.Solicitud</v-col>
                                                <v-col class="my-0 py-0">
                                                    <v-btn class="ma-2" tile large color="green" dense icon>
                                                        <v-icon>mdi-check-box-outline</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-row justify="start" class="align-center text-left">
                                                <v-col class="my-0 py-0 text-left">2.Respuesta Suministro</v-col>
                                                <v-col class="my-0 py-0">
                                                    <v-btn class="ma-2" tile large color="green" dense icon>
                                                        <v-icon>mdi-check-box-outline</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-row justify="start" class="align-center text-left">
                                                <v-col class="my-0 py-0 text-left">3.Cierre</v-col>
                                                <v-col class="my-0 py-0">
                                                    <v-btn class="ma-2" tile large color="grey" dense icon>
                                                        <v-icon>mdi-check-box-outline</v-icon>
                                                    </v-btn>
                                                    <v-btn class="ma-2" tile large color="grey" dense icon>
                                                        <v-icon>mdi-close-box-outline</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col class="justify-center text-center">
                                                    <a href="#" class="text-decoration-none">Ver detalles</a>
                                                    
                                                </v-col>
                                            </v-row>
                                           
                                       </v-card>
                                    </v-col>
                                    <v-col class="border-left-light-blue border-bottom-2 border-right-2 pa-0" cols="12" lg="4">
                                         <v-card
                                        color="#F0F4FF"
                                        height="57"
                                        class="bar-info-offers mb-10"
                                        elevation="0"
                                       >    
                                        <v-card-title class="pa-0">
                                            
                                                <v-col class="text-center white--text light-blue darken-1">
                                                    <v-icon color="white">mdi-theme-light-dark</v-icon>
                                                    C
                                                </v-col>
                                               <v-col cols="2" class="text-center pa-0">
                                                    <p class="caption mb-0">estado</p>
                                                    <v-icon color="#439A03">mdi-check-circle</v-icon>
                                                </v-col>
                                                <v-col class="pa-0" cols="4">
                                                    <p class="caption mb-0">Horario</p>
                                                    <h5>0am a 8am</h5>
                                                </v-col>
                                                <v-col class="pa-0" cols="3" >
                                                    <p class="caption mb-0">Requiere</p>
                                                    <h3>10MW</h3>
                                                </v-col>

                                        </v-card-title>
                                       </v-card> 
                                        <v-card 
                                            class="outline-0 py-6 px-3 ma-6 card-max-width mx-auto rounded-xl text-center overflow-hidden outline-red"
                                            color="#fff">
                                            <v-img
                                                    class="mx-auto"
                                                    max-width="70%"
                                                    alt="Neocity Logo"
                                                    src="@/assets/images/neocity-logo.png"
                                                    contain
                                            ></v-img>
                                            <v-col class="mx-auto" cols="8">
                                                <b>
                                                    A - 1000<br>
                                                    X. Los Lagos, 220Kv<br>
                                                    +50 MW
                                                </b>
                                            </v-col>
                                            <div class="mx-auto">
                                              
                                                <v-chip
                                                        class="ma-2"
                                                        color="#0172C0"
                                                        label
                                                        text-color="white"
                                                >
                                                    C
                                                </v-chip>
                                            </div>
                                            <div class="mx-auto">
                                                <b>6 Meses</b>
                                            </div>
                                            <b>Precio: <span class="green--text">30 USD/MWh</span></b>
                                            <v-rating
                                                    :value="'4'"
                                                    readonly
                                                    background-color="orange lighten-3"
                                                    color="orange"
                                                    >
                                            </v-rating>
                                            <v-progress-linear height="10px"
                                                color="red"
                                                value="18">
                                            </v-progress-linear>
                                            <v-row justify="start" class="align-center text-left">
                                                <v-col class="my-0 py-0 text-left">1.Solicitud</v-col>
                                                <v-col class="my-0 py-0">
                                                    <v-btn class="ma-2" tile large color="green" dense icon>
                                                        <v-icon>mdi-check-box-outline</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-row justify="start" class="align-center text-left">
                                                <v-col class="my-0 py-0 text-left">2.Respuesta Suministro</v-col>
                                                <v-col class="my-0 py-0">
                                                    <v-btn class="ma-2" tile large color="grey" dense icon>
                                                        <v-icon>mdi-check-box-outline</v-icon>
                                                    </v-btn>
                                                     <v-btn class="ma-2" tile large color="red" dense icon>
                                                        <v-icon>mdi-close-box-outline</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-row justify="start" class="align-center text-left">
                                                <v-col class="my-0 py-0 text-left">3.Cierre</v-col>
                                                <v-col class="my-0 py-0">
                                                    <v-btn class="ma-2" tile large color="grey" dense icon>
                                                        <v-icon>mdi-check-box-outline</v-icon>
                                                    </v-btn>
                                                    <v-btn class="ma-2" tile large color="grey" dense icon>
                                                        <v-icon>mdi-close-box-outline</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col class="justify-center text-center">
                                                    <a href="#" class="text-decoration-none">Ver detalles</a>
                                                    
                                                </v-col>
                                            </v-row>
                                           
                                       </v-card>
                                    </v-col>
                                </v-row>
                            </v-card>
                   

                

                </v-card>
            </v-col>
            <v-col cols="12">
                <v-card 
                    class="d-flex text-right fixed-action justify-end align-center" 
                    >
                     <v-btn color="primary"
                        x-large
                        class="px-12 mx-6">Enviar Solicitudes
                    </v-btn>
                    <v-btn color="primary"
                         x-large
                        outlined
                        class="px-12 mx-6">Contratar Suministro
                    </v-btn>
                    </v-card>
            </v-col>

        </v-row>


    </v-col>
</template>
<style lang="scss">

.pasos-contrato{
    position: absolute;
    top: -33px;
    left: 50%;
    margin-left: -35%;
    .v-toolbar__content{
        padding: 0px !important;
    }
        border-radius: 30px 0px 0 30px !important;
    .v-toolbar__title{
        position: relative;
        padding: 0 25px;
        overflow: inherit !important;

         &.first{
            text-align: center;
            color: #0172C0 !important;
            font-weight: 800;
            font-size: 18px;
        } 
        
        &.step{
            &.second{
                border-radius: 40px 0px 0 40px !important;
                &::before {
                    content: none;
                    border-left: none;
                    border-top: none;
                    border-bottom: none;
                    position: inherit;
                    top: 0;
                    left: 0;
                }
            }
        text-align: left;
        padding-left: 40px;
        line-height: 18px;
        font-size: 16px;
         margin: 0 1.8px;
         display: flex;
         align-items: center;
         &.active{
            background: #0172C0 !important;
            color: orange !important;
             &::after {
                border-left: 20px solid #0172C0;
            }
         }
         height: 60px !important;
         background: #D2D2D2 !important;
         color: #969696 !important;

            &::before {
                content: '';
                border-left: 20px solid #ffffff;
                border-top: 30px solid transparent;
                border-bottom: 30px solid transparent;
                position: absolute;
                top: 0;
                left: 0;
            }
            &::after {
                content: '';
                border-left: 20px solid #D2D2D2;
                border-top: 30px solid transparent;
                border-bottom: 30px solid transparent;
                position: absolute;
                top: 0;
                left: 100%;
                z-index: 20;
            }

        }

        
        
    }
    
    
}
.fixed-action{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.4) !important;
    padding-right: 280px !important;
    height: 80px;
}
.shadow-double{
    box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.15) ,
    10px -8px 0px 0px #DBDBDB,
    20px -15px 0px 0px #BFBFBF !important;
}
.tabs-offers .v-tab{
    width: 50%;
    max-width: 50%;
}
.bar-info-offers{
    color: #67676A ;
}
.buscador{
    height: 60px;
}
.buscador .v-text-field__slot{
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}
.hover-outline-green:hover{
    border: 3px solid #4C901B !important;
     box-shadow: 0px 0px 10px rgba(76, 144, 27, 0.64)  !important;
}
.outline-green{
    border: 3px solid #4C901B !important;
     box-shadow: 0px 0px 10px rgba(76, 144, 27, 0.64)  !important;
}
.outline-red{
    border: 3px solid #FF0100 !important;
     box-shadow: 0px 0px 10px rgba(255, 1, 0, 0.64)  !important;
}
</style>
<script>
    export default {
        name: 'RequestTracking',
        data: () => ({
           tab:'',
           viewMode:'card',
           closings:{
                    search:'',
                    headers: [
                        { text: 'Código', value: 'code' },
                        { text: 'Suministrador', value: 'supplier' },
                        { text: 'Precio Energia (USD/MWh)', value: 'EnergyPrice' },
                        { text: 'Precio Potencia (USD/MW-mes', value: 'PricePower' },
                        { text: 'Cuenta Mensual (USD)', value: 'MonthlyAccount' },
                        { text: 'Periodo de suministro (Meses)', value: 'SupplyPeriod' },
                        { text: 'Bloques Horarios', value: 'TimeBlocks' },
                        { text: 'Tipo de Tecnoloigia', value: 'TypeOfTechnology' },
                        { text: 'Respuesta Generador', value: 'GeneratorResponse', class:'rotateTh' },
                        { text: 'Cierre del contrato', value: 'ContractClosing' , class:'rotateTh'},
                        { text: 'Cierre del contrato', value: 'ContractClosing' , class:'rotateTh'},
                        { text: 'Info del Suministrador', value: 'SupplierInfo' , class:'rotateTh'},
                        { text: 'Diferencia (USD)', value: 'DifferenceUSD' },

                    ],
                    data: [
                        {
                            color:'',
                            code: 'A-1000',
                            supplier: 'San Andres SpA',
                            EnergyPrice: '30.0',
                            PricePower: '10.0',
                            MonthlyAccount: '456.789',
                            SupplyPeriod: '6',
                            TimeBlocks:['A','B','C'],
                            TypeOfTechnology: 'Solar',
                            GeneratorResponse:true,
                            ContractClosing:false,
                            SupplierInfo:{
                                hour: '12:00',
                                info:'info'
                            },
                            DifferenceUSD:'26.200',
                          
                        },
                        {
                            color:'',
                            code: 'A-1002',
                            supplier: 'San Andres SpA',
                            EnergyPrice: '30.0',
                            PricePower: '10.0',
                            MonthlyAccount: '456.789',
                            SupplyPeriod: '6',
                            TimeBlocks:['A','B','C'],
                            TypeOfTechnology: 'Solar',
                            GeneratorResponse:true,
                            ContractClosing:false,
                            SupplierInfo:{
                                hour: '12:00',
                                info:'info'
                            },
                            DifferenceUSD:'26.200',
                           
                        },
                        {
                            color:'blue lighten-5',
                            code: 'A-1003',
                            supplier: 'San Andres SpA',
                            EnergyPrice: '30.0',
                            PricePower: '10.0',
                            MonthlyAccount: '456.789',
                            SupplyPeriod: '6',
                            TimeBlocks:['A','B','C'],
                            TypeOfTechnology: 'Solar',
                            GeneratorResponse:true,
                            ContractClosing:false,
                            SupplierInfo:{
                                hour: '12:00',
                                info:'info'
                            },
                            DifferenceUSD:'26.200',
                           
                        },
                        {
                            color:'red lighten-5',
                            code: 'A-1004',
                            supplier: 'San Andres SpA',
                            EnergyPrice: '30.0',
                            PricePower: '10.0',
                            MonthlyAccount: '456.789',
                            SupplyPeriod: '6',
                            TimeBlocks:['A','B','C'],
                            TypeOfTechnology: 'Solar',
                            GeneratorResponse:true,
                            ContractClosing:false,
                            SupplierInfo:{
                                hour: '12:00',
                                info:'info'
                            },
                            DifferenceUSD:'26.200',
                           
                        },
                        {
                            color:'grey lighten-3',
                            code: 'A-1005',
                            supplier: 'San Andres SpA',
                            EnergyPrice:'30.0',
                            PricePower: '10.0',
                            MonthlyAccount: '456.789',
                            SupplyPeriod: 6,
                            TimeBlocks:['A','B','C'],
                            TypeOfTechnology: 'Solar',
                            GeneratorResponse:true,
                            ContractClosing:null,
                            SupplierInfo:{
                                hour: '12:00',
                                info:'info'
                            },
                            DifferenceUSD:'26.200',
                           
                        },
                    ],
                },
           
        }),
        computed: {
          
        },
        methods: {
            
        },
         created: function () {
            this.$emit('SetcolorMenu', '#FE9A00');
        }
    }
</script>